import { Button, Modal, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

interface BackendUnavailableModalProps {
	open: boolean;
	isChecking: boolean;
	onRefresh: () => void;
}

const BackendUnavailableModal: React.FC<BackendUnavailableModalProps> = ({
	open,
	isChecking,
	onRefresh,
}) => (
	<Modal
		title="Backend Server Unavailable"
		open={open}
		centered
		closable={false}
		maskClosable={false}
		footer={
			<Button type="primary" loading={isChecking} onClick={onRefresh}>
				Refresh
			</Button>
		}
	>
		<div style={{ textAlign: 'center', padding: '16px 0' }}>
			<Text>Unable to reach the backend server.</Text>
			<div style={{ marginTop: 8 }}>
				<Text type="secondary">
					Click &quot;Refresh&quot; to check again, or contact admin support.
				</Text>
			</div>
		</div>
	</Modal>
);

export default BackendUnavailableModal;
